(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var toastEl = $('#toast'), tt;
  function toast(html) { if (!toastEl) return; toastEl.innerHTML = html; toastEl.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500); }
  function setCount(n) { $$('[data-cart-count]').forEach(function (e) { e.textContent = n; }); }

  function money(cents) {
    var v = cents / 100, f = window.moneyFormat || 'Rs. {{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-IN');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('de-DE');
      return v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* mobile menu */
  var mt = $('[data-menu-toggle]');
  if (mt) mt.addEventListener('click', function () {
    var open = $('#nav').classList.toggle('is-open'); mt.setAttribute('aria-expanded', open);
  });

  /* cart helpers */
  function refreshCount() {
    return fetch(window.cartJs || '/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function done() { return refreshCount().then(function () { toast('Added to cart <a href="' + window.cartUrl + '">View cart</a>'); }); }
  function fail(err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); }

  /* ajax add (product form + card forms) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-add]')) return;
    e.preventDefault();
    var btn = $('[type=submit]', f), old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(window.cartAddJs || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(done).catch(fail)
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
  });

  /* quick add from product cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    var old = b.textContent; b.disabled = true; b.textContent = '…';
    fetch(window.cartAddJs || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(done).catch(fail)
      .finally(function () { b.disabled = false; b.textContent = old; });
  });

  /* buy now from product cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-buy-now]');
    if (!b) return;
    e.preventDefault();
    var old = b.textContent; b.disabled = true; b.textContent = '…';
    fetch(window.cartAddJs || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: parseInt(b.getAttribute('data-buy-now'), 10), quantity: 1 }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) { fail(err); b.disabled = false; b.textContent = old; });
  });

  /* hero slider */
  $$('[data-slider]').forEach(function (s) {
    var track = $('.hero__track', s), dots = $$('[data-dot]', s), i = 0, n = dots.length, timer;
    if (n < 2) return;
    function go(k) { i = (k + n) % n; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () { var k = Math.round(track.scrollLeft / track.clientWidth); dots.forEach(function (d, x) { d.classList.toggle('is-on', x === k); }); i = k; });
    dots.forEach(function (d, x) { d.addEventListener('click', function () { go(x); }); });
    dots[0].classList.add('is-on');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var start = function () { timer = setInterval(function () { go(i + 1); }, 5000); };
      s.addEventListener('mouseenter', function () { clearInterval(timer); }); s.addEventListener('mouseleave', start); start();
    }
  });

  /* modals */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-open-modal]');
    if (o) { var m = document.getElementById(o.getAttribute('data-open-modal')); if (m && m.showModal) m.showModal(); return; }
    if (e.target.closest && e.target.closest('[data-close-modal]')) { var d = e.target.closest('dialog'); if (d) d.close(); return; }
    if (e.target.matches && e.target.matches('dialog[data-modal]')) e.target.close();
  });

  /* collection: filter drawer, sort, grid density */
  var drawer = $('[data-drawer]');
  if (drawer) {
    var setDrawer = function (on) { drawer.classList.toggle('is-open', on); document.body.style.overflow = on ? 'hidden' : ''; };
    $$('[data-open-filters]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
    $$('[data-close-filters]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
  }
  $$('[data-sort]').forEach(function (s) { s.addEventListener('change', function () { var f = s.form; if (f.requestSubmit) f.requestSubmit(); else f.submit(); }); });
  $$('[data-view]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = $('[data-coll-grid]'); if (!g) return;
      g.setAttribute('data-cols', b.getAttribute('data-view'));
      $$('[data-view]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    });
  });

  /* recommendations */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t;
      var n = $('[data-recs]', d);
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    }).catch(function () {});
  });

  /* reviews: show more */
  $$('[data-more-reviews]').forEach(function (b) {
    b.addEventListener('click', function () { $$('[data-more]').forEach(function (r) { r.hidden = false; }); b.remove(); });
  });

  /* product page */
  $$('[data-product]').forEach(function (p) {
    var data = $('[data-variants]', p); if (!data) return;
    var variants = JSON.parse(data.textContent), idEl = $('[data-variant-id]', p), add = $('[data-add]', p), priceEl = $('[data-price]', p);
    var groups = $$('[data-option-group]', p);
    var sticky = $('[data-sticky-atc]'), stickyBtn = $('[data-sticky-btn]'), stickyPrice = $('[data-sticky-price]');
    var gallery = $('[data-gallery]', p), goTo = function () {};

    /* gallery */
    if (gallery) {
      var track = $('[data-track]', gallery), slides = $$('[data-slide]', gallery), thumbs = $$('[data-thumb]', gallery), count = $('[data-count]', gallery), idx = 0, st;
      var mark = function (k) { idx = Math.max(0, Math.min(slides.length - 1, k)); thumbs.forEach(function (t, x) { t.classList.toggle('is-on', x === idx); }); if (count) count.textContent = idx + 1; };
      goTo = function (k) { mark(k); track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' }); };
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60); });
      thumbs.forEach(function (t, x) { t.addEventListener('click', function () { goTo(x); }); });
      var pv = $('[data-prev]', gallery), nx = $('[data-next]', gallery);
      if (pv) pv.addEventListener('click', function () { goTo(idx - 1); });
      if (nx) nx.addEventListener('click', function () { goTo(idx + 1); });
      $$('[data-zoom]', gallery).forEach(function (z) {
        z.addEventListener('mouseenter', function () { z.classList.add('is-zoom'); });
        z.addEventListener('mouseleave', function () { z.classList.remove('is-zoom'); });
        z.addEventListener('mousemove', function (e) { var r = z.getBoundingClientRect(); z.style.setProperty('--x', ((e.clientX - r.left) / r.width * 100) + '%'); z.style.setProperty('--y', ((e.clientY - r.top) / r.height * 100) + '%'); });
      });
      var showImage = function (id) { slides.forEach(function (s, x) { if (String(s.getAttribute('data-image-id')) === String(id)) goTo(x); }); };
      gallery._show = showImage;
    }

    /* variants */
    function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function matches(v, opts) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); }
    function find(opts) { return variants.filter(function (v) { return matches(v, opts); })[0]; }
    function availability() {
      var opts = selected();
      groups.forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var ok = variants.some(function (v) { return matches(v, test) && v.available; });
          if (inp.nextElementSibling) inp.nextElementSibling.classList.toggle('is-out', !ok);
        });
        var lab = $('[data-opt-label]', g), c = $('input:checked', g); if (lab && c) lab.textContent = c.value;
      });
    }
    function setBtns(label, disabled) {
      [add, stickyBtn].forEach(function (b) { if (b) { b.disabled = disabled; b.textContent = label; } });
    }
    function update() {
      availability();
      var v = find(selected());
      if (!v) { setBtns('Unavailable', true); return; }
      idEl.value = v.id; setBtns(v.available ? 'Add to Cart' : 'Sold out', !v.available);
      var onSale = v.compare_at_price > v.price;
      var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      priceEl.innerHTML = onSale ? '<s>' + money(v.compare_at_price) + '</s> <strong class="price--sale">' + money(v.price) + '</strong> <span class="badge badge--inline">Save ' + pct + '%</span>' : '<strong>' + money(v.price) + '</strong>';
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      if (v.featured_image && gallery && gallery._show) gallery._show(v.featured_image.id);
    }
    $$('[data-option]', p).forEach(function (r) { r.addEventListener('change', update); });
    availability();

    /* quantity */
    $$('[data-qty]', p).forEach(function (b) { b.addEventListener('click', function () {
      var q = $('[name=quantity]', p); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10)); }); });

    /* sticky add-to-cart bar */
    if (sticky && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(add);
    }

    /* delivery estimate */
    var del = $('[data-delivery]', p);
    if (del) {
      var pin = $('[data-pin]', del), msg = $('[data-pin-msg]', del), mn = parseInt(del.getAttribute('data-min'), 10) || 4, mx = parseInt(del.getAttribute('data-max'), 10) || 7;
      var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var check = function () {
        if (!/^[1-9][0-9]{5}$/.test(pin.value.trim())) { msg.textContent = 'Please enter a valid 6-digit pincode.'; return; }
        var a = new Date(), b = new Date(); a.setDate(a.getDate() + mn); b.setDate(b.getDate() + mx);
        msg.textContent = 'Estimated delivery: ' + fmt(a) + ' – ' + fmt(b);
      };
      $('[data-pin-check]', del).addEventListener('click', check);
      pin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    }

    /* share */
    var sh = $('[data-share]', p);
    if (sh) sh.addEventListener('click', function () {
      var data = { title: sh.getAttribute('data-title'), url: location.href.split('?')[0] };
      if (navigator.share) navigator.share(data).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { toast('Link copied'); });
    });
  });
})();
